/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_Cat_1Inputs */

const en_mk_context_cat_1 = /** @type {(inputs: Mk_Context_Cat_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product & Pricing`)
};

const id_mk_context_cat_1 = /** @type {(inputs: Mk_Context_Cat_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk & Harga`)
};

/**
* | output |
* | --- |
* | "Product & Pricing" |
*
* @param {Mk_Context_Cat_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_cat_1 = /** @type {((inputs?: Mk_Context_Cat_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_Cat_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_cat_1(inputs)
	return en_mk_context_cat_1(inputs)
});